import { render } from "./menuStartAllApps.vue?vue&type=template&id=95f0ee36&scoped=true"
import script from "./menuStartAllApps.vue?vue&type=script&lang=js"
export * from "./menuStartAllApps.vue?vue&type=script&lang=js"

import "./menuStartAllApps.vue?vue&type=style&index=0&id=95f0ee36&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-95f0ee36"

export default script